import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { useApp } from "@/context/AppContext";
import API from "@/lib/api";
import { timeAgo } from "@/lib/format";
import { Plus } from "lucide-react";

const STATUS = {
  open: { label: "Aperta", cls: "bg-[#FFF6DA] text-[#141A3A]" },
  with_availabilities: { label: "Con disponibilità", cls: "bg-[#EEF0FB] text-[#1D4ED8]" },
  contact: { label: "Contatto avviato", cls: "bg-[#FFF8E7] text-[#9A6B00]" },
  resolved: { label: "Risolta", cls: "bg-[#E8F5E9] text-[#2E7D32]" },
  closed: { label: "Chiusa", cls: "bg-[#EEE] text-[#4A4E68]" },
  expired: { label: "Scaduta", cls: "bg-[#EEE] text-[#4A4E68]" },
};

export default function MyRequests() {
  const navigate = useNavigate();
  const { getCategory, catName } = useApp();
  const [items, setItems] = useState(null);

  useEffect(() => { API.get("/requests/mine").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <Layout>
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-serif text-2xl font-bold text-[#0F1230]">Le mie richieste</h1>
        <button data-testid="new-request-button" onClick={() => navigate("/")} className="inline-flex items-center gap-1 bg-[#1F4FE0] text-white rounded-full px-4 h-10 text-sm font-medium"><Plus size={16} /> Nuova</button>
      </div>

      {items === null ? <p className="text-[#4A4E68]">Caricamento...</p> : items.length === 0 ? (
        <div className="bg-white rounded-[18px] border border-[#DADFEA] p-6 text-center">
          <p className="text-[#2A2E48] mb-3">Non hai ancora pubblicato richieste.</p>
          <button onClick={() => navigate("/")} className="bg-[#1F4FE0] text-white rounded-full px-5 h-11 font-medium">Pubblica la prima</button>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((r) => {
            const cat = getCategory(r.category);
            const st = STATUS[r.status] || STATUS.open;
            return (
              <button key={r.id} data-testid={`my-request-${r.id}`} onClick={() => navigate(`/request/${r.id}`)} className="text-left w-full bg-white rounded-[18px] border border-[#DADFEA] p-4 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${st.cls}`}>{st.label}</span>
                  <span className="text-xs text-[#4A4E68] ml-auto">{timeAgo(r.created_at)}</span>
                </div>
                <h3 className="font-semibold text-[#0F1230]">{r.title}</h3>
                <p className="text-sm text-[#4A4E68]">{cat ? catName(cat) : r.category} · {r.is_online ? "Online" : r.city}</p>
                <p className="text-sm text-[#141A3A] mt-1 font-medium">{r.availability_count}/{r.max_availabilities} disponibili</p>
              </button>
            );
          })}
        </div>
      )}
    </Layout>
  );
}
